var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationMarker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 18,
    viewBox: "0 0 13 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.74081 1.40625C3.8372 1.40625 1.48145 3.64842 1.48145 6.40996C1.48145 9.58749 4.98769 14.623 6.27514 16.3622C6.32858 16.4356 6.39863 16.4954 6.47955 16.5366C6.56048 16.5778 6.65001 16.5992 6.74081 16.5992C6.83162 16.5992 6.92114 16.5778 7.00207 16.5366C7.083 16.4954 7.15305 16.4356 7.20649 16.3622C8.49394 14.6237 12.0002 9.59005 12.0002 6.40996C12.0002 3.64842 9.64442 1.40625 6.74081 1.40625Z",
    stroke: "#525252",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.74092 8.41872C7.70914 8.41872 8.49404 7.63382 8.49404 6.6656C8.49404 5.69738 7.70914 4.91248 6.74092 4.91248C5.77269 4.91248 4.98779 5.69738 4.98779 6.6656C4.98779 7.63382 5.77269 8.41872 6.74092 8.41872Z",
    stroke: "#525252",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationMarker);
export default __webpack_public_path__ + "static/media/location-marker.ce7800d9ecd61344b6d50d963e9bdcc0.svg";
export { ForwardRef as ReactComponent };